import { KeywordTableColumn } from './models';

export const getColumnId = (column: KeywordTableColumn) => `${column.type}-${column.id}`;
